<template>
  <div v-if="selectedProducts.length||applyType===APPLY_PRODUCT_OPTIONS.prefixProduct" class="mt-3">
    <div class="flex justify-end items-center mb-2">
      <button
        :disabled="isLoading"
        @click="handleOpenModalProducts"
        class="fs-14 flex items-center gap-1 justify-center border-0 focus:outline-none bg-indigo-50 text-blue-900 rounded-lg h-10 px-3 py-2"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 16C28 16.2652 27.8946 16.5196 27.7071 16.7071C27.5196 16.8946 27.2652 17 27 17H17V27C17 27.2652 16.8946 27.5196 16.7071 27.7071C16.5196 27.8946 16.2652 28 16 28C15.7348 28 15.4804 27.8946 15.2929 27.7071C15.1054 27.5196 15 27.2652 15 27V17H5C4.73478 17 4.48043 16.8946 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H15V5C15 4.73478 15.1054 4.48043 15.2929 4.29289C15.4804 4.10536 15.7348 4 16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V15H27C27.2652 15 27.5196 15.1054 27.7071 15.2929C27.8946 15.4804 28 15.7348 28 16Z"
            fill="currentColor"
          />
        </svg>
        {{ $t('Chọn sản phẩm') }}
      </button>
    </div>
    <el-table :data="selectedProducts" border style="width: 100%">
      <el-table-column type="index" label="STT"></el-table-column>
      <el-table-column min-width="300" prop="name" :label="$t('Tên sản phẩm')"></el-table-column>
      <el-table-column prop="sku" :label="$t('Số đăng ký')"></el-table-column>
      <el-table-column prop="ecom_manufacturer.name" :label="$t('Nhà sản xuất')"></el-table-column>
      <el-table-column prop="ecom_origin.name" :label="$t('Nước sản xuất')"></el-table-column>
    </el-table>
    <ModalListMkProducts
      ref="ModalListMkProducts"
      @onChangeSelectedProducts="handleChangeSelectedProducts"
      @onSelectedAll="handleSelectedAllProducts"
    />
  </div>
</template>

<script>
import { APPLY_PRODUCT_OPTIONS } from './HodoCreditLayout.vue'
import ModalListMkProducts from './ModalListMkProducts.vue'

export default {
  name: 'SelectedProducts',
  components: { ModalListMkProducts },
  props: {
    applyType: Number,
    selectedProducts: Array
  },
  data () {
    return {
      isLoading: false,
      APPLY_PRODUCT_OPTIONS
    }
  },
  methods: {
    handleOpenModalProducts () {
      this.$refs.ModalListMkProducts.handleOpenModal(true)
    },
    handleChangeSelectedProducts (data) {
      this.$emit('onChangeSelectedProducts', data)
    },
    handleSelectedAllProducts () {
      this.$emit('onSelectedAll', APPLY_PRODUCT_OPTIONS.allProduct)
      this.$message({
        message: this.$t('Chọn tất cả sản phẩm thành công'),
        type: 'success'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-container * {
  color: black;
}

::v-deep {
  thead * {
    color: black !important;
  }
}
</style>